import * as React from "react";
import {cx} from "emotion";

import "./static-tooltip.scss";

import {cs} from "@Common/react/chain-services";

export const StaticTooltip = ({color, position, text, onClose=undefined}) => cs(
    () => (
        <div className="static-tooltip-2iv">
            <div
                className={cx(
                    "box", color, position, {closable: onClose},
                )}
            >
                <div className="text">
                    {text}
                </div>

                {onClose && (
                    <button className="close" onClick={onClose}>
                        &times;
                    </button>
                )}
            </div>
        </div>
    ),
);